import { TermsOfUseService } from "@/services/termsOfUse.service";
import TermsOfUseModal from "@/pages/modals/TermsOfUseModal.vue";
import { isMobile } from "mobile-device-detect";

export const termsOfUseMixin = {
  methods: {
    async checkAndShowTermsModal(enroll) {
      if (!enroll) return true;
      const { courseId, applicationId, applicationUserId } = enroll;

      const termsStatus = await this.$store.dispatch("enroll/fetchTermsOfUseStatus", { courseId, applicationId });
      if (!termsStatus?.requiresAcceptance) return true;

      return this.showTermsModal({ courseId, applicationId, applicationUserId }, termsStatus);
    },

    showTermsModal(enroll, termsStatus) {
      return new Promise((resolve) => {
        const closeModal = () => {
          this.$modal.hide("TermsOfUseModal");
        };

        const acceptHandler = async () => {
          try {
            await TermsOfUseService.acceptTerms(
              termsStatus.term.id,
              true,
              termsStatus.term.courseId,
              enroll.applicationUserId,
              enroll.applicationId
            );

            await this.$store.dispatch("enroll/acceptTermsOfUse", {
              courseId: enroll.courseId,
              applicationUserId: enroll.applicationUserId
            });

            this.$nextTick(() => {
              closeModal();
              resolve(true);
            });
          } catch (error) {
            this.$store.commit("toast/NEW", {
              type: "error",
              message: "Erro ao aceitar os termos. Tente novamente.",
              suppressOffline: true,
            });
            resolve(false);
          }
        };

        const rejectHandler = async () => {
          try {
            await TermsOfUseService.acceptTerms(
              termsStatus.term.id,
              false,
              termsStatus.term.courseId,
              enroll.applicationUserId,
              enroll.applicationId
            );
            closeModal();
            this.$store.commit("toast/NEW", {
              type: "info",
              message: "Você precisa aceitar os termos para acessar este conteúdo.",
            });
          } catch (error) {
            this.$store.commit("toast/NEW", {
              type: "error",
              message: "Erro ao processar rejeição dos termos.",
              suppressOffline: true,
            });
            closeModal();
          } finally {
            const NON_CONTENT_ROUTES = ["login"];
            const previousPath = this.$router.from;
            const canGoBack = previousPath?.name && !NON_CONTENT_ROUTES.includes(previousPath.name);
            canGoBack ? this.$router.back() : await this.$router.push("/p/my-courses");

            resolve(false);
          }
        };

        this.$modal.show(
          TermsOfUseModal,
          {
            term: termsStatus.term,
            isUpdate: termsStatus.isUpdate,
            updatedAt: termsStatus.updatedAt,
            acceptHandler,
            rejectHandler,
          },
          {
            name: "TermsOfUseModal",
            width: isMobile ? "95%" : "600px",
            height: "auto",
            transition: "slide-bottom",
            scrollable: true,
            styles: "border-radius: 10px;",
            classes: this.$theme.darkTheme ? "bg-color-modal-dark" : "bg-color-modal-light",
          }
        );
      });
    },
  },
};
